import React, { Fragment } from 'react';
import './bars.scss';
import useFormatParties from '../../dataProvider/hooks/useFormatParties';

const Bars = ({ currentData, pastData, orientation = "vertical" }) => {
  const partyFormats = useFormatParties(currentData, pastData);

  if (!partyFormats) {
    return <div>Loading</div>;
  }

  const formatModel = partyFormats.filter(
    item => item.seats || item.previousSeat
  );

  return (
    <Fragment>
      <div className={orientation + "_barsScroll"}>
        <div className={orientation + "_bars"}>
          {formatModel.map((party, index) => (
            <div className="party" key={index}>
              <div className="partyInfo">
                <h3 className="partyName">{party.partyAcronym}</h3>

                <span
                  className={
                    party.seats > party.previousSeat
                      ? "partyEscanos more"
                      : "partyEscanos less"
                  }
                >
                  {Math.abs(party.seats - party.previousSeat)}
                </span>
              </div>
              <div className="barsContainer">
                <div
                  className="bar bar_current"
                  style={{
                    backgroundColor: party.partyColor,
                    width:
                      orientation === "horizontal"
                        ? ((party.seats * 100) / currentData.totalSeats) * 2.3 + "%"
                        : undefined,
                    height:
                      orientation === "vertical"
                        ? ((party.seats * 100) / currentData.totalSeats) * 2.3 + "%"
                        : undefined
                  }}
                >
                  <span className="barEscanos">{party.seats}</span>
                </div>
                <div
                  className="bar bar_past"
                  style={{
                    backgroundColor: party.partyColor,
                    width:
                      orientation === "horizontal"
                        ? ((party.previousSeat * 100) / pastData.totalSeats) * 2.3 +
                          "%"
                        : undefined,
                    height:
                      orientation === "vertical"
                        ? ((party.previousSeat * 100) / pastData.totalSeats) * 2.3 +
                          "%"
                        : undefined
                  }}
                >
                  <span className="barEscanos">{party.previousSeat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default Bars;
